import { LoanCarBooking } from "../modals/LoanCarBooking";
import { RescheduleVehicleBooking } from "../modals/RescheduleVehicleBooking";
import APIService from "./APIService";
// import { APIService } from "./APIService";

export class IBSService {
  private apiService = new APIService();

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {}

  getTasksForUser(taskId: string) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/GetTasksForUser/${taskId}`,
      "GET",
      null
    );
  }

  addTask(taskListId: string, taskObj: any) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/AddTask/TaskList/${taskListId}`,
      "POST",
      taskObj
    );
  }

  updateTask(taskId: string, taskObj: any) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/editTask/${taskId}`,
      "POST",
      taskObj
    );
  }

  deleteTask(taskId: string) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/DeleteTask/${taskId}`,
      "POST",
      {}
    );
  }

  rescheduleBooking(estimateId: string, bookingObj: RescheduleVehicleBooking) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/RescheduleVehicleBooking/${estimateId}`,
      "POST",
      bookingObj
    );
  }

  getLoanCars() {
    return this.apiService.sendRequest(
      "/api/iBodyShop/GetLoanCar/486de059-b439-4796-9a20-23512e4d33cd",
      "POST",
      {}
    );
  }

  getLoanCarsBookings(startDate: string, endDate: string) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/GetLoanCarViewSlider?startDate=${startDate}&endDate=${endDate}`,
      "POST",
      {}
    );
  }

  getEmailTemplates(jobId: any) {
    return this.apiService.sendRequest(
      "/api/iBodyShop/EmailMessageTemplates/" + jobId,
      "GET",
      null
    );
  }

  sendMail(obj: any) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/EmailSend/`,
      "POST",
      obj
    );
  }

  textMessageSuggestions(id: any) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/TextMessageSuggestions/${id}`,
      "GET",
      null
    );
  }

  sendSMS(smsDetails: any) {
    return this.apiService.sendRequest(
      "/api/iBodyShop/SendSMS",
      "POST",
      smsDetails
    );
  }

  createLoanCarBookings(body: LoanCarBooking) {
    return this.apiService.sendRequest(
      "/api/iBodyShop/CreateLoanCarBooking",
      "POST",
      body
    );
  }

  getEstimatePlanning(estimateId: string) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/EstimatePlanning/${estimateId}`,
      "GET",
      null
    );
  }

  addNote(estimateId: string, body: any) {
    return this.apiService.sendRequest(
      `/api/iBodyShop/AddNotes/${estimateId}`,
      "POST",
      body
    );
  }
}

export default IBSService;
